// extracted by mini-css-extract-plugin
export default {"iconBut":"BlockPage_iconBut__EJlnB","delBlocks":"BlockPage_delBlocks__FrGUV","addBlock":"BlockPage_addBlock__g4GTw","BlockPageTable":"BlockPage_BlockPageTable__Ayars"};